import { Component, OnInit, Input } from '@angular/core';
import { Shared } from '../shared.service';

@Component({
  selector: 'boardlink',
  templateUrl: './boardlink.component.html',
  styleUrls: ['./boardlink.component.scss']
})
export class BoardlinkComponent implements OnInit {

  @Input() uuid;
  @Input() save_obs;
  boardlink;
  cached_uuid;
  boardlink_obs;
  boardlink_ref;

  constructor(public shared: Shared) { }

  ngOnInit() {
      this.cached_uuid = ''+this.uuid;
      this.boardlink_ref = this.shared.getBoardlink(this.uuid);
      this.boardlink_obs = this.boardlink_ref.snapshotChanges().map(action => {
        const $key = action.payload.key;
        return {$key, ...action.payload.val()};
      });
      this.boardlink_obs.subscribe(boardlink => {
          console.log(boardlink);
          this.boardlink = boardlink;
      });
      this.save_obs.subscribe(() => {
        delete this.boardlink['$key'];
        this.boardlink_ref.update(this.boardlink);
      });
  }

  ngOnChanges(){
      if(this.cached_uuid != this.uuid){
          this.ngOnInit();
      }

  }

}



// WEBPACK FOOTER //
// ./src/app/boardlink/boardlink.component.ts